export default __webpack_public_path__ + "static/media/connect.00c89722.jpg";